import { Object3D } from "three";
import { BoxObject } from "./BoxObject";
import { PlacementObject } from "./PlacementObject";
import { FrontFaceObject } from "./FrontFaceObject";
import { InsideElementObject } from "./InsideElementObject";
import { BoneObject } from "./BoneObject";
import { PlinthObject } from "./PlinthObject";

export class CabinetObject extends Object3D {

    public Box?: BoxObject;
    public Placement!: PlacementObject;
    public Plinth?: PlinthObject;
    public FrontFaces : FrontFaceObject[] = [];
    public InsideElements: InsideElementObject[] = [];
    public Bones: BoneObject[] = [];

    constructor(name: string) {
        super();
        this.name = name;
    }
}
